import { DirectoryRole } from 'Services/Api/Directory/Types';

export const SUPERADMIN_ROLE_ID = 1;

export const ROLE_LABEL: Record<string, string> = {
	superadmin: 'Superadmin',
	admin: 'Leadership & IT Team',
	manager: 'Manager',
	user: 'Staff'
}

const ROLE_DISPLAY_LABEL: Record<string, string> = {
	superadmin: 'learning.roleDisplayLabel.superadmin',
	admin: 'learning.roleDisplayLabel.admin',
	manager: 'learning.roleDisplayLabel.manager',
	user: 'learning.roleDisplayLabel.user'
};

const ROLE_DESCRIPTION : Record<string, string> = {
	admin: 'learning.roleDescription.admin',
	manager: 'learning.roleDescription.manager',
	user: 'learning.roleDescription.user'
};

const normalize = (value: string) => value.trim().toLowerCase();

export const roleDisplayLabel = (name: string) => ROLE_DISPLAY_LABEL[normalize(name)] ?? name;

export const roleDescription = (name: string) => ROLE_DESCRIPTION[normalize(name)] ?? '';

export const isSuperAdminRole = (role: DirectoryRole) => role.id === SUPERADMIN_ROLE_ID || normalize(role.name) === 'superadmin';

export const visibleRoles = <T extends DirectoryRole>(roles: T[]) => roles.filter((role) => !isSuperAdminRole(role));

const roleMatchesSearch = (name: string, search: string) => {
	const term = normalize(search);
	if (!term) return true;
	return [name, (ROLE_LABEL[normalize(name)] ?? name)].some((value) => normalize(value).includes(term));
};

export const filterRolesForUser = <T extends DirectoryRole>(
	roles: T[],
	search = ''
) => visibleRoles(roles).filter((role) => roleMatchesSearch(role.name, search));

export const pluralLabel = (label: string, count: number | undefined) => {
	return `${label}${count === 1 ? '_one' : '_other'}`;
}

export const restoreScreenScroll = (containerSelector: string, topSpacing: number) => {
	const container = document.querySelector(containerSelector);
	if(container) container.scrollTo({ top: topSpacing, behavior: "auto" });
};